import React from 'react';
import PropTypes from 'prop-types';

import SelectInput from '../../common/inputs/select-input';
import { getLanguage, list } from '../../../services/interface-languages';

import { saveDateFormatConfig } from 'app/scripts/components/common/inputs/api/save-date-format-config';
import { withEditSpot } from '../../../../spots/hoc/withEditSpot';

class InterfaceLanguage extends React.Component {
  shouldComponentUpdate(nextProps) {
    var { value, spotId } = this.props;
    return value !== nextProps.value || spotId !== nextProps.spotId;
  }

  handleLanguageChange(language) {
    const { spotId } = this.props;
    this.props.editSpot(spotId, { main_language: language.value });
    saveDateFormatConfig(spotId, language.dateFormat).catch(console.error);
  }

  render() {
    var value = this.props.value;
    var language = getLanguage(value);

    return (
      <div className="language-selection">
        <SelectInput
          title="Interface Language"
          description="Select the language for interface elements such as buttons and descriptions."
          onChange={this.handleLanguageChange.bind(this)}
          options={list}
          value={language}
        />
        {value !== 'en' && value !== 'en_GB' ? (
          <div className="language-note">
            {' '}
            <b>Note:</b> Some extended features not fully supported in this language.{' '}
          </div>
        ) : null}
      </div>
    );
  }
}

InterfaceLanguage.propTypes = {
  value: PropTypes.string,
  spotId: PropTypes.string
};

InterfaceLanguage.displayName = 'InterfaceLanguage';

export default withEditSpot(InterfaceLanguage);
